module.exports = __webpack_public_path__ + "img/Edit.cda77bfa.svg";